import { render } from "./ListScroll.vue?vue&type=template&id=bcfe25dc&scoped=true"
import script from "./ListScroll.vue?vue&type=script&lang=js"
export * from "./ListScroll.vue?vue&type=script&lang=js"

import "./ListScroll.vue?vue&type=style&index=0&id=bcfe25dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bcfe25dc"

export default script